"use client";

import Image from "next/image";
import { useRouter } from "next/navigation";
import Link from "next/link";
import React, { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { convertToAMPM } from "@/utils/convertToAMPM";
import { formatPhoneNo } from "@/utils/formatPhoneNo";
import Loader from "@/components/Loader";
import { setStoreList } from "@/redux/slices/storeSlice";
import { useGetStoreListsQuery } from "@/redux/apiSlices/storeApi";
import CallIcon from "@/icons/CallBoldIcon";
import ClockIcon from "@/icons/ClockIcon";
import LocationIcon from "@/icons/LocationIcon";
import LocationIconImg from "@/assets/images/location-icon-img.png";
import { Button } from "@/components/ui/button";

const StoreGrid = ({title}) => {
  const { data, isSuccess, isFetching } = useGetStoreListsQuery();
  const dispatch = useDispatch();
  const router = useRouter();

  // Memoize the store list data to prevent unnecessary updates
  const storeListsData = useMemo(() => data?.data || [], [data]);

  useEffect(() => {
    if (isSuccess) {
      // Dispatch action only if there is new data
      dispatch(setStoreList(storeListsData));
    }
  }, [isSuccess, storeListsData, dispatch]);

  return (
    <div className="container max-w-1440 px-7  mx-auto 1440:px-5 1440:w-full lg:bg-white pb-[64px] pt-[49px] lg:pb-6 lg:rounded-b-[15px] ">
    <h2 className="text-[26px] font-black leading-[39px] mb-[19px]">
      {title}
    </h2>

    {isFetching ? (
     <Loader />  
    ) : (
      <ul className="grid grid-cols-4 gap-[24px] mxl:grid-cols-3  mlg:grid-cols-2 md:grid-cols-1">
            {storeListsData?.length > 0 &&
              storeListsData.map((item) => (
              <div
                key={item.id}
                className="rounded-[14px] p-[20px] border border-peach2 bg-white"              
              >
                <div onClick={() => router.push(`stores/${item?.slug}`)} className="cursor-pointer">
                  <div className="flex justify-between items-center mb-3">
                    <h3 className=" text-blue6 font-bold text-[18px] leading-[22px]">
                      {item?.storeName}
                    </h3>
                    <Image
                      className="w-[46px] h-[46px]"
                      src={LocationIconImg}
                      alt="icon"
                    />
                  </div>
                  <div className="flex  gap-[7px] mb-[15px]">
                    <LocationIcon />
                    <p className=" text-[14px] leading-[18px]">
                      {item?.address} {item?.city}, {item?.state} {item?.zipCode}
                    </p>
                  </div>
                </div>
                <div className="flex  gap-[7px] mb-[15px]">
                  <ClockIcon />
                  <div>
                    <h4 className=" font-bold text-[15px] leading-[18px] mb-1 ">
                      Open Hours
                    </h4>
  
                    <p className="text-[14px]">
                      {`Mon - Fri: ${
                        convertToAMPM(item?.weekdayStartTime) || ""
                      } to ${convertToAMPM(item?.weekdayEndTime) || ""}`}
                    </p>

                    <p className=" text-[14px] leading-[22px]">
                    
                      {item?.storeManagerName !=="AA" && <>Sat & Sun: {convertToAMPM(item?.weekendStartTime)} to{" "}
                      {convertToAMPM(item?.weekendEndTime)}</>}
                      {item?.storeManagerName ==="AA" && <>Saturday: {convertToAMPM(item?.weekendStartTime)} to{" "}
                      {convertToAMPM(item?.weekendEndTime)}</>}                
                    </p>
                    <p className=" text-[14px] leading-[22px]">
                    {item?.storeManagerName ==="AA" && <>Sunday: Closed</>}
                    </p>
                  </div>
                </div>
                <div className="flex  gap-[7px] mb-[15px]">
                  <CallIcon />
                  <div>
                    <h4 className=" font-bold text-[15px] leading-[18px] mb-1 ">
                      Phone
                    </h4>
                    <p className="text-[14px]">
                      {formatPhoneNo(item?.phone)}
                    </p>
                  </div>
                </div>
                <div className=" flex gap-4 sm:grid   sm:grid-cols-2 xsm:grid-cols-1">
                  <Link 
                    href={"tel:+1"+item?.phone }
                    aria-label={"call +1"+item?.phone}
                    className=" text-center text-[12px] leading-[14px] py-[9px] px-[13px] h-[34px] border border-blue2 bg-transparent text-blue2 rounded-[4px] hover:bg-inherit	">
                    Contact Store
                  </Link>

                  <Button className="text-[12px] leading-[14px] py-[9px] px-[13px] h-[34px] border border-blue2 bg-transparent text-blue2 rounded-[4px] hover:bg-inherit" 
                    onClick={() => router.push(`stores/${item?.slug}`)}>
                      Store Info
                  </Button>
                </div>
              </div>
            ))}   
      </ul>
    )}
  </div>
  );
};

export default StoreGrid;